import {
    CompanyConfiguration,
    EtaEvent,
    GpsPosition,
    PositionTestEventRequest,
    QueuedEvent,
    QueuedEventAndConfig,
    ScriptErrorLogEntry,
    StopLocation,
    TelematicState,
    TransportOrder,
    TransportOrderChange,
    TransportOrderTestEventRequest
} from "../../../../../generated/api";
import {workingConfig} from "../../configChange/ConfigSignal";
import {
    exportSimErrors,
    exportSimInputIds,
    exportSimOutputIndex,
    exportSimOutputs,
    getCurrentExportSimOutput
} from "./input/ExportSimPrepareSide";
import {EventEnum} from "../../scriptExecution/scriptRunner/QueuedEventCreator";
import {authentication} from "../../../../../authentication";
import {notify} from "react-notify-toast";
import {backend} from "../../../../../xconvert-backend";
import {v4 as uuid} from 'uuid';
import {
    scriptConvPlaygroundScript,
    scriptConvPlaygroundScriptPath
} from "../../configChange/ScriptConverterPlayground/ScriptConverterPlayground";

const auth = backend.withTokenAuthHeader(authentication.token);

export async function sendEvent(
    context: any,
    order: TransportOrder,
    orderId: string,
    selectedEvent: EventEnum,
    changeType: TransportOrderChange.TypeEnum,
    status: string | null,
    telematicStateCode: TelematicState.StatusCodeEnum,
    beforeSend?: (xReqId: string) => void,
    onSend?: (
        response: any,
        queuedEvent: QueuedEvent,
        respondedConfig: any,
        encoding: string,
        logEntry?: ScriptErrorLogEntry
    ) => void
): Promise<string> {
    switch (selectedEvent) {
        case EventEnum.ASSIGN_COMPANY_EVENT:
            return convert(context, order, orderId, TransportOrderTestEventRequest.EventTypeEnum.ASSIGNCOMPANY, null, null, beforeSend, onSend)
        case EventEnum.STATUS_UPDATE_EVENT:
            return convertStatus(context, order, orderId, changeType, status, telematicStateCode, beforeSend, onSend)
        case EventEnum.STORNO_EVENT:
            return convert(context, order, orderId, TransportOrderTestEventRequest.EventTypeEnum.STORNO, null, null, beforeSend, onSend)
        case EventEnum.UPDATE_EVENT:
            return convert(context, order, orderId, TransportOrderTestEventRequest.EventTypeEnum.UPDATE, null, null, beforeSend, onSend)
        case EventEnum.POSITION_EVENT:
            return convertPosition(context, order, orderId, onSend)
        case EventEnum.ETA_EVENT:
            return convertEtaEvent(context)
        default:
            notify.show('Event must be selected ', 'error', 5000, '#fc0303');
            return null
    }
}

export async function orderToEvent(
    context: any,
    order: TransportOrder,
    orderId: string,
    eventType: TransportOrderTestEventRequest.EventTypeEnum,
    status: string | null,
    telematicStateStatus: TelematicState.StatusCodeEnum | null,
): Promise<QueuedEventAndConfig> {

    let orderCompanyId = null
    if (context.exportSimOrderCompanyId && context.exportSimOrderCompanyId != "") {
        orderCompanyId = context.exportSimOrderCompanyId
    }

    let telematicState = null
    if (telematicStateStatus != null) {
        telematicState = {} as TelematicState
        telematicState.statusCode = telematicStateStatus
    }

    let request = {} as TransportOrderTestEventRequest
    request.configCompanyId = context.companyId
    request.eventType = eventType
    request.newStatus = status
    request.telematicState = telematicState
    request.orderCompanyId = orderCompanyId
    request.transportOrder = order
    request.transportOrderId = orderId
    request.config = JSON.parse(workingConfig.value)

    return await backend.internalApi.getTransportOrderTestEvent(request, auth)
}

async function convert(
    context: any,
    order: TransportOrder,
    orderId: string,
    eventType: TransportOrderTestEventRequest.EventTypeEnum,
    status: string | null,
    telematicStateStatus: TelematicState.StatusCodeEnum | null,
    beforeSend?: (xReqId: string) => void,
    onSend?: (
        response: any,
        queuedEvent: QueuedEvent,
        respondedConfig: any,
        encoding: string,
        logEntry?: ScriptErrorLogEntry
    ) => void
): Promise<string> {

    try {
        let data = await orderToEvent(
            context,
            order,
            orderId,
            eventType,
            status,
            telematicStateStatus
        )

        exportSimInputIds.value.push(data.event._id)
        return sendEventToConverter(
            context,
            data.event,
            data.config,
            onSend,
            beforeSend,
            orderId
        )

    } catch (e) {
        notify.show('Error while sending event: ' + e, 'error', 5000, '#fc0303');
        console.log(e)
    }
    return null
}

export async function orderToPositionEvent(
    context: any,
    order: TransportOrder,
    orderId: string,
): Promise<QueuedEventAndConfig> {
    let position = {} as GpsPosition
    position.latitude = 42
    position.longitude = 42
    position.timestamp = new Date
    position.accuracyInM = 1


    let request = {} as PositionTestEventRequest
    request.configCompanyId = context.companyId
    request.transportOrder = order
    request.transportOrderId = orderId
    request.config = JSON.parse(workingConfig.value)
    request.position = position


    let data = await backend.internalApi.getPositionTestEvent(request, auth)

    console.log(data);
    return data
}

async function convertPosition(
    context: any,
    order: TransportOrder,
    orderId: string,
    onSend: (
        response: any,
        queuedEvent: QueuedEvent,
        respondedConfig: any,
        encoding: string,
        logEntry?: ScriptErrorLogEntry
    ) => void
): Promise<string> {

    try {

        let data = await orderToPositionEvent(
            context,
            order,
            orderId
        )

        return sendEventToConverter(
            context,
            data.event,
            data.config,
            onSend,
            null,
            orderId
        )

    } catch (ex) {
        console.log(ex)
        return null
    }
}

export function orderToQueuedEtaEvent(
    order: TransportOrder,
): QueuedEvent {
    let stops = [] as StopLocation[]
    order.transports.forEach(t => {
        t.stops.forEach(s => {
            stops.push(s)
        })
    })


    let gpsPosition = {} as GpsPosition
    gpsPosition.accuracyInM = 10
    gpsPosition.latitude = order.transports[0].stops[0].coordinates.latitude
    gpsPosition.longitude = order.transports[0].stops[0].coordinates.longitude
    gpsPosition.timestamp = new Date()

    let etaEvent = {} as EtaEvent
    etaEvent.currentPosition = gpsPosition
    etaEvent.transportOrder = order
    etaEvent.driver = order.assignedDriver
    etaEvent.vehicle = order.assignedVehicle
    etaEvent.nextStops = stops
    etaEvent.timestamp = new Date()

    let queuedEvent = {} as QueuedEvent
    queuedEvent._id = "testId"
    queuedEvent.companyId = this.context.companyId
    queuedEvent.eventType = QueuedEvent.EventTypeEnum.ETAEVENT
    queuedEvent.etaEvent = etaEvent
    queuedEvent.timestamp = new Date()

    return queuedEvent
}

function convertEtaEvent(context: any): Promise<string> {
    try {
        let order = JSON.parse(this.context.exportSimTo) as TransportOrder
        let queuedEvent = orderToQueuedEtaEvent(order)

        return sendEventToConverter(
            context,
            queuedEvent,
            JSON.parse(workingConfig.value),
            null,
            null,
            order._id
        )

    } catch (ex) {
        console.log(ex)
        return null
    }
}

async function convertStatus(
    context: any,
    order: TransportOrder,
    orderId: string,
    changeType,
    status: string | null,
    telematicStateCode: TelematicState.StatusCodeEnum | null,
    beforeSend?: (xReqId: string) => void,
    onSend?: (
        response: any,
        queuedEvent: QueuedEvent,
        respondedConfig: any,
        encoding: string,
        logEntry?: ScriptErrorLogEntry
    ) => void
): Promise<string> {
    if ((status == null && telematicStateCode == null) || changeType == null) {

        console.log("(status and telematicStateCode) or changeType empty")
        notify.show("Please select a status or telematicStateCode or changeType", 'error', 5000, '#fc0303');
        return null
    }
    console.log("status: " + status + "telematicStateCode: " + telematicStateCode + " changetype: " + changeType)
    return convert(context, order, orderId, changeType, status, telematicStateCode, beforeSend, onSend)
}

export function resetOutputs() {
    exportSimOutputs.value = []
    exportSimInputIds.value = []
    exportSimOutputIndex.value = 0
}

export async function sendEventToConverter(
    context: any,
    event: QueuedEvent,
    config: CompanyConfiguration,
    onSend?: (
        response: any,
        queuedEvent: QueuedEvent,
        respondedConfig: any,
        encoding: string,
        logEntry?: ScriptErrorLogEntry
    ) => void,
    beforeSend ?: (xReqId: string) => void,
    orderId ?: string,
): Promise<string> {

    let url = '/converter/v3/convertQueuedEventToExternalFormat'
    if (context.customConverterBasePath != null) {
        url = context.customConverterBasePath + url
    }
    let xReqId = uuid()
    if (beforeSend) {
        beforeSend(xReqId)
    }
    let response = await fetch(url, {
        method: 'POST',
        headers: {
            "Content-Type": "application/json; charset=utf-8",
            'x-request-id': xReqId
        },
        body: JSON.stringify({
            queuedEvent: event,
            config: config,
        })
    })

    let decoded = null
    let output = null
    try {
        decoded = await decodeResponse(response)

        console.log("ExportSimPrepareSide - decoded response: ", decoded)
        let index = -1
        if (event._id) {
            index = exportSimInputIds.value.indexOf(event._id)
        } else {
            index = exportSimInputIds.value.indexOf(orderId)
        }

        console.log("[ExportSimOutput] Saving result in index: ", index)
        if (index === -1) {
            index = exportSimOutputs.value.length
            exportSimInputIds.value.push(event._id)
        }
        console.log("[ExportSimOutput] Setting exportSimOutputs at index " + index)
        output = decoded.text
        // Reassign a new array reference so the signal notifies subscribers
        // (in-place mutation would not trigger the load effect in ExportSimOutput).
        const newOutputs = [...exportSimOutputs.value]
        newOutputs[index] = output
        exportSimOutputs.value = newOutputs
        context.setExportSimOutputEncoding(decoded.encoding)

    } catch (e) {
        console.log("Error decoding response: ", e)
    }

    let logEntry: ScriptErrorLogEntry = null

    let errorMessage: string = null
    if (!response.ok) {

        if (scriptConvPlaygroundScript.value != null && scriptConvPlaygroundScriptPath.value != null) {

            logEntry = {} as ScriptErrorLogEntry

            logEntry.queuedEvent = event as QueuedEvent
            logEntry.script = scriptConvPlaygroundScript.value
            logEntry.scriptPath = scriptConvPlaygroundScriptPath.value
            logEntry.user = authentication.user
            logEntry.logs = [] // will be filled async later, since it's not in graylog by now
            logEntry.companyId = context.companyId
            logEntry.config = workingConfig.value
            logEntry.xRequestId = xReqId
            logEntry.createdAt = new Date()
            logEntry.converterResponseStatus = response.status
            logEntry.converterResponseObjectDecoded = decoded
            logEntry.testType = ScriptErrorLogEntry.TestTypeEnum.EXPORT
        }

        errorMessage = response.statusText

        if (output != null) {
            errorMessage += ": " + output
        }
    }


    console.log("setting exportSimOutput to: " + getCurrentExportSimOutput())
    onSend(
        response,
        event,
        config,
        decoded?.encoding,
        logEntry
    )
    return errorMessage
}

async function decodeResponse(response) {

    if (response.status == 204) {
        return {text: "204 - No Content", encoding: "ISO-8859-1", activeConverter: null, activeSpecificConfig: null}
    }
    let contentType = await response.headers.get('content-type').toString()

    let localEncoding = contentType.substring(contentType.indexOf("charset=") + 8)


    console.log("ENCODING: " + localEncoding)

    let buffer = await response.arrayBuffer()
    let decoder = new TextDecoder(localEncoding);
    let text = decoder.decode(buffer);

    // extract converter info to display it in ExportSimOutput
    let activeConverter = null;
    let activeSpecificConfig = null;
    try {
        const parsed = JSON.parse(text);
        activeConverter = parsed.activeConverter;
        activeSpecificConfig = parsed.activeSpecificConfig;
    } catch (e) {
        console.log("Could not parse response for converter info");
    }

    return {text: text, encoding: localEncoding, activeConverter, activeSpecificConfig}
}